import AuthRequestHelper from "./AuthRequestHelper";
import config from '../config/config';

class UserProfileHelper {
    constructor() {}

    // Method to fetch a user profile by ID
    async getUserProfileById(user_id = "") {
        try {
            const requestUrl = `/getUserProfileById/${user_id}`;
            let response = await AuthRequestHelper.request("get", requestUrl, {});
            return response?.data || {};
        } catch (error) {
            console.error('Error fetching user profile by ID:', error);
            return false;
        }
    }

    // Method to fetch bots owned by a user
    async getUserBots(user_id = "") {
        try {
            const requestUrl = `/getBotIdsByUserId/${user_id}`;
            let response = await AuthRequestHelper.request("get", requestUrl, {});
            return response?.data || [];
        } catch (error) {
            console.error('Error fetching bots for user profile:', error);
            return [];
        }
    }

    // Method to edit (update) a user profile
    async updateUserProfile(user_id = "", updateData = {}) {
        try {
            const requestUrl = `/updateUserProfile/${user_id}`;
            let response = await AuthRequestHelper.request("patch", requestUrl, updateData);
            if(response?.status === "success")
            {
                return response?.updatedData || {};
            }
            throw new Error(response)
        } catch (error) {
            console.error('Error updating user profile:', error);
            return false;
        }
    }

    // Method to add a new user profile
    async addUserProfile(userProfileData) {
        try {
            const requestUrl = '/addUserProfile';
            let response = await AuthRequestHelper.requestNoToken("put", requestUrl, userProfileData);
            return response?.data || {};
        } catch (error) {
            console.error('Error adding user profile:', error);
            return false;
        }
    }

    // Method to fetch all user profile IDs
    async getAllUserProfileIds() {
        try {
            const requestUrl = '/getAllUserProfileIds';
            let response = await AuthRequestHelper.request("get", requestUrl, {});
            return response?.data || [];
        } catch (error) {
            console.error('Error fetching all user profile IDs:', error);
            return [];
        }
    }
}

export default new UserProfileHelper();